import type { Menu } from '@/menus/types.ts';
import businessServiceContract from './business-service-contract';
import customsDeclaration from './customs-declaration';
import taxRefund from './tax-refund';
import vehicleDelivery from './vehicle-delivery';
export default [
  ...customsDeclaration,
  ...vehicleDelivery,
  ...taxRefund,
  ...businessServiceContract,
] satisfies Menu[];
